import { Component, Input, inject } from '@angular/core';
import {FormControl} from '@angular/forms';
import {RadioVraag, SelectVraag, TextareaVraag, TextVraag, VerkeerslichtVraag, Vraag} from '../../vraag';
import {DialogService} from '../../../core/dialog/dialog.service';

@Component({
    selector: 'zah-signaalkaart-vraag',
    templateUrl: './signaalkaart-vraag.component.html',
    styleUrls: ['./signaalkaart-vraag.component.scss'],
    standalone: false
})
export class SignaalkaartVraagComponent {
  private dialogService = inject(DialogService);

  @Input()
  vraag: Vraag;
  @Input()
  control: FormControl;

  getTextVraag(): TextVraag {
    return this.vraag as TextVraag;
  }

  getTextAreaVraag(): TextareaVraag {
    return this.vraag as TextareaVraag;
  }

  getRadioVraag(): RadioVraag {
    return this.vraag as RadioVraag;
  }

  getVerkeerslichtVraag(): VerkeerslichtVraag {
    return this.vraag as VerkeerslichtVraag;
  }

  openUitleg(verkeerslichtVraag: VerkeerslichtVraag): void {
    this.dialogService.showInformation(verkeerslichtVraag.getUitleg());
  }

  getSelectVraag(): SelectVraag {
    return this.vraag as SelectVraag;
  }

  getSelectedOptionsLabel(): string {
    if (this.control.value instanceof Array) {
      const optionIds = this.control.value as Array<string>;
      return optionIds
        .map(optionId => this.getSelectVraag().getOption(optionId))
        .map(option => option.getLabel())
        .join(', ');
    } else {
      const optionId = this.control.value as string;
      return this.getSelectVraag().getOption(optionId)?.getLabel();
    }
  }
}

